<template lang="pug">
  .region-list(v-if="regions && regions[0] && regions[0].code")
    slot(:regions="regions" :regions-by-letter="regionsByLetter")

</template>

<script>
  import vueColorbarSvc from '@services/vueColorbarSvc';

  export default {
    name: "RegionList",

    data() {
      return {
        regions: null,
      };
    },

    computed: {
      regionsByLetter() {
        const regionsByLetter = [
          { name: 'A', regions: [] },
          { name: 'B', regions: [] },
          { name: 'C', regions: [] },
          { name: 'D', regions: [] },
          { name: 'E', regions: [] },
          { name: 'F', regions: [] },
          { name: 'G', regions: [] },
          { name: 'H', regions: [] },
          { name: 'I', regions: [] },
          { name: 'J', regions: [] },
          { name: 'K', regions: [] },
          { name: 'L', regions: [] },
          { name: 'M', regions: [] },
          { name: 'N', regions: [] },
          { name: 'O', regions: [] },
          { name: 'P', regions: [] },
          { name: 'Q', regions: [] },
          { name: 'R', regions: [] },
          { name: 'S', regions: [] },
          { name: 'T', regions: [] },
          { name: 'U', regions: [] },
          { name: 'V', regions: [] },
          { name: 'W', regions: [] },
          { name: 'X', regions: [] },
          { name: 'Y', regions: [] },
          { name: 'Z', regions: [] }
        ];

        if (!this.regions || !this.regions.length) {
          return [];
        }

        this.regions.forEach(region => {
          const firstLetter = region.name.charAt(0).toUpperCase();
          const letterGroup = regionsByLetter.find(group => group.name === firstLetter);
          if (letterGroup) {
            letterGroup.regions.push(region);
          }
        });

        return regionsByLetter.filter(group => group.regions.length);
      },
    },

    mounted() {
      vueColorbarSvc.getAllRegions().then(res => {
        this.regions = res.data;
      });
    },
  };
</script>

<style scoped lang="stylus">
</style>
